import { Container } from 'react-bootstrap';
import '../style/service.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useRef } from 'react';
import { db } from '../database/firebase';
import { collection,getDocs } from 'firebase/firestore';
import { useState,useEffect } from 'react';
import { doc,updateDoc,deleteDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

export default function Service() {
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState(""); // حالة لتخزين الرابط النشط

  const handleClick = (e, path) => {
    e.preventDefault(); // منع إعادة تحميل الصفحة
    setActiveLink(path); // تحديث المسار النشط
    navigate(path); // التنقل باستخدام React Router
  };

  const [services, setserivces] = useState([]); 
  const [uppp,setuppp]=useState("")
  useEffect(() => {
      const fetchUsers = async () => {
          const querySnapshot = await getDocs(collection(db, "serivces"));
          const usersArray = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
          setserivces(usersArray);
          console.log(services)

        };
        fetchUsers();

  }, [uppp]);


  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const nextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  return (
    <div className='services-section'>
      <Container>
        <div className='title-up'>
          <div className='left-t'>
            <h2>
              Wir bieten immer den <br /> besten Service
            </h2>
          </div>
          <div className='right-t'>
            <h4>Dienstleistungen</h4>
            <p>
              Wir können Ihren Reinigungsplan zwar an Ihre Bedürfnisse anpassen,{' '}
              <br /> die meisten Kunden vereinbaren jedoch regelmäßige
              Reinigungsdienste:
            </p>
          </div>
        </div>
        <div className='my-hr'></div>

        <div className='slider-box'>
          <div className='slider-container'>
            <Slider ref={sliderRef} {...settings}>
              {services.map(item => (
                <div key={item.id} className='slide'>
                  <div className='card-ser'>
                    <img src={item.img} alt={item.img} />
                    <h3>{item.title}</h3>
                    <p>
                    {item.text}
                    </p>
                    <button onClick={(e) => handleClick(e, "/contact")} className='card-btn'>
                    Jetzt bestellen<i class='fa-solid fa-arrow-right'></i>
                    </button>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className='next-button-container'>
            <button className='next-button' onClick={nextSlide}>
            <i class='fa-solid fa-arrow-right'></i>
            </button>
          </div>
        </div>

      </Container>
    </div>
  );
}
